<template>
  <div class="container">
    <label :for="getName" class="label" v-if="label">{{ label }}</label>

    <div class="input-container" :style="{ height: label ? 'calc(100% - 30px)' : '100%' }">
      <input :class="inputClasses"
             :id="id"
             autocomplete="off"
             :name="getName"
             :placeholder="placeholderText"
             @focusin="isFocused = true"
             @focusout="isFocused = false"
             :type="getInputType"
             v-model="value"/>
      <div class="eye-icon-container" @mouseenter="showPassword = true" @mouseleave="showPassword = false">
        <span v-show="hidden && showPassword" style="margin-right: 1px;"><i class="far fa-eye eye-icon"></i></span>
        <span v-show="hidden && !showPassword"><i class="far fa-eye-slash eye-icon"></i></span>
      </div>
      <span class="bar"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputText",
  props: {
    id: {
      type: String,
      required: true
    },
    name: String,
    label: String,
    initialValue: String,
    initialValueNumber: Number,
    placeholder: String,
    showError: Boolean,
    hidden: Boolean,
    isNumber: Boolean,
    newValue: String
  },
  data() {
    return {
      value: this.getInitialValue(),
      isFocused: false,
      hasError: this.showError,
      showPassword: false
    };
  },
  methods: {
    getName() {
      return this.name ? this.name : 'default name';
    },
    getInitialValue() {
      if (this.initialValue) {
        return this.initialValue;
      }
      if (this.initialValueNumber) {
        return this.initialValueNumber;
      }
      return null;
    }
  },
  computed: {
    placeholderText() {
      return this.placeholder ? this.placeholder : '';
    },
    inputClasses() {
      if (this.hasError) {
        return 'error-input';
      }
      return this.isFocused ? 'transparent-border' : 'no-transparent-border';
    },
    getInputType() {
      if (this.isNumber) {
        return 'number'
      }
      return this.hidden && !this.showPassword ? 'password' : 'text';
    }
  },
  watch: {
    // emit action when value changed
    value(newVal, oldVal) {
      // when value changed - clear the error
      this.hasError = false;

      if (this.isNumber) {
        oldVal = parseInt(oldVal);
        newVal = parseInt(newVal);
      }

      this.$emit('value-change', {
        id: this.id,
        name: this.getName(),
        label: this.label,
        oldValue: oldVal,
        currentValue: newVal
      });
    },
    showError(newVal) {
      this.hasError = newVal;
    },
    newValue(newVal) {
      this.value = newVal;
    }
  }
}
</script>

<style scoped>
@import "../../../css/shared/input.css";

input {
  border: 0;
  border-bottom: 2px solid;
  background-color: var(--very-light-grey);
  float: left;
  height: calc(100% - 15px);
  width: inherit;
  padding: 0 6px;
  box-sizing: border-box;
}

.eye-icon-container {
  float: right;
  margin-top: -36px;
  margin-right: 10px;
  height: fit-content;
  width: fit-content;
}

.eye-icon {
  position: relative;
  font-size: 1.4em;
}

.eye-icon:hover {
  cursor: pointer;
  color: var(--primary-blue);
}

input:focus {
  outline-color: transparent;
  outline-style: none;
  border-color: transparent;
}

input[type='text'], input[type='password'], input[type='number'] {
  font-size: 20px;
  font-family: Arial, Helvetica, sans-serif;
}

.bar {
  position: relative;
  float: left;
  display: block;
  width: 100%;
}

.bar:before, .bar:after {
  content: '';
  height: 2px;
  width: 0;
  bottom: 0;
  position: absolute;
  background: var(--primary-blue);
  transition: 0.3s ease all;
  -moz-transition: 0.3s ease all;
  -webkit-transition: 0.3s ease all;
}

.bar:before {
  left: 50%;
}

.bar:after {
  right: 50%;
}

/* active state */
input:focus ~ .bar:before, input:focus ~ .bar:after {
  width: 50%;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: var(--grey);
  opacity: 0.5;
}

:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: var(--grey);
}

::-ms-input-placeholder {
  /* Microsoft Edge */
  color: var(--grey);
}
</style>
